module.exports = __webpack_public_path__ + "static/media/msg-coach.bd23e0f1.svg";